import { createFileRoute } from '@tanstack/react-router';
import { QUERY_KEYS } from '~shared/api/query-keys';
import { getCurrentUserAPI } from '~entities/users/api/get-current-user';

export const Route = createFileRoute('/_auth/_layout')({
  loader: ({ context: { queryClient } }) => 
    queryClient.ensureQueryData({
        queryKey: QUERY_KEYS.CURRENT_USER(),
        queryFn: getCurrentUserAPI,
    }),
});
